// src/pages/ExploreAuthors.jsx

import React, { useState, useEffect } from 'react';
import { useDebounce } from '../../hooks/useDebounce';
import SectionHeader from '../../components/home/exploreBooksComponents/SectionHeader';
import AuthorManager from '../../services/home/AuthorManager';
import AuthorGrid from '../../components/home/exploreAuthorComponents/AuthorGrid';

const ExploreAuthors = () => {
  const [query, setQuery] = useState('');
  const debouncedQuery = useDebounce(query, 500);
  const [authors, setAuthors] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // New: view state
  const [view, setView] = useState('grid');

  // Fetch (or search) authors
  const fetchAuthors = async () => {
    setLoading(true);
    try {
      let data = [];

      if (debouncedQuery.trim()) {
        const res = await AuthorManager.searchAuthorsByName(debouncedQuery.trim());
        data = res.responseData ?? []; // Correctly access responseData array
      } else {
        data = await AuthorManager.getAllAuthors();
        data = data.responseData ?? []; // Correctly access responseData array
      }

      const mapped = data.map(a => ({
        id: a.authorId ?? a.id,
        name: a.authorName ?? a.name,
        image: a.authorImage ?? a.image ?? '/images/default-author.png',
        aboutAuthor: a.aboutAuthor ?? '',
      }));

      setAuthors(mapped);
    } catch (err) {
      console.error('Error fetching authors:', err);
      setAuthors([]);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchAuthors();
  }, [debouncedQuery]);

  return (
    <div className="min-h-screen bg-white">
      <SectionHeader
        title="Explore Authors"
        placeholder="Search authors by name"
        onSearch={setQuery}
        onViewChange={setView}   // <-- wire the view toggle
        view={view}              // <-- current view for highlighting
      />

      <div className="container mx-auto px-4 py-2">
        <AuthorGrid
          authors={authors}
          loading={loading}
          view={view}            // <-- render grid or list
          onViewChange={setView} // <-- allow grid/list toggle inside the grid itself, if desired
        />

        {!loading && authors.length === 0 && (
          <div className="mt-6 text-center text-gray-500">
            No authors found for this search.
          </div>
        )}
      </div>
    </div>
  );
};

export default ExploreAuthors;
